<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
  <app-sub-header [pageTitle]="'FuelPurchase' | translate"></app-sub-header>

  <div class="padded-container">
    <form (ngSubmit)="saveClick()">
      <ng-container *ngIf="isLoaderSelected; else carForm">
        <dx-form>
          <dxi-item>
            <dxo-label text="{{ 'FuelAmount' | translate }}"></dxo-label>
            <dx-number-box
              [(value)]="fuelAmount"
              [min]="0"
              [max]="1000"
              [step]="0.01"
              [showSpinButtons]="true"
              [format]="{ type: 'fixedPoint', precision: 2 }"
              class="full-width-button">
            </dx-number-box>
          </dxi-item>
          <dxi-item>
            <div class="engine-hours-hints" *ngIf="lastEngineHours != null || todayEngineHours != null">
              <span *ngIf="lastEngineHours != null">{{ 'LastEngineHours' | translate }}: {{ lastEngineHours }}</span>
              <span *ngIf="consumedEngineHours != null">{{ 'ConsumedEngineHours' | translate }}: {{ consumedEngineHours }}</span>
            </div>
            <dxo-label text="{{ 'EngineHours' | translate }}"></dxo-label>
            <dx-number-box [(value)]="engineHours"
              [min]="0"
              [step]="1"
              [showSpinButtons]="true"
              [format]="'decimal'"
              [valueChangeEvent]="'input'"
              (onValueChanged)="onEngineHoursChanged($event)"
              class="full-width-button">
            </dx-number-box>
          </dxi-item>
          <dxi-item>
            <dxo-label text="{{ 'ReceiptNumber' | translate }}"></dxo-label>
            <dx-number-box [(value)]="fuelReceiptNumber"
                           [min]="0"
                           [max]="999999999"
                           [showSpinButtons]="true"
                           [format]="'decimal'"
                           class="full-width-button"></dx-number-box>
          </dxi-item>
          <dxi-item *ngIf="carAndLoader && carAndLoader.length > 1">
            <dxo-label text="{{ 'Vehicles' | translate }}"></dxo-label>
            <dx-select-box 
              [(value)]="selectedCarAndLoader" 
              [dataSource]="carAndLoader" 
              displayExpr="carNumber" 
              valueExpr="id" 
              class="full-width-button" 
              (onValueChanged)="onSelectedVehicleChanged($event)"
              placeholder="{{ 'SelectVehicle' | translate }}">
            </dx-select-box>
          </dxi-item>
          <dxi-item>
            <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="success" (onClick)="saveClick()"></dx-button>
          </dxi-item>
          <dxi-item>
            <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="navigateToVoucher()"></dx-button>
          </dxi-item>
        </dx-form>
      </ng-container>
      <ng-template #carForm>
        <dx-form>
          <dxi-item>
            <dxo-label text="{{ 'FuelAmount' | translate }}"></dxo-label>
            <dx-number-box
              [(value)]="fuelAmount"
              [min]="0"
              [max]="1000"
              [step]="0.01"
              [showSpinButtons]="true"
              [format]="{ type: 'fixedPoint', precision: 2 }"
              class="full-width-button">
            </dx-number-box>
          </dxi-item>
          <dxi-item>
            <dxo-label text="{{ 'ReceiptNumber' | translate }}"></dxo-label>
            <dx-number-box [(value)]="fuelReceiptNumber"
                           [min]="0"
                           [max]="999999999"
                           [showSpinButtons]="true"
                           [format]="'decimal'"
                           class="full-width-button"></dx-number-box>
          </dxi-item>
          <dxi-item *ngIf="carAndLoader && carAndLoader.length > 1">
            <dxo-label text="{{ 'Vehicles' | translate }}"></dxo-label>
            <dx-select-box 
              [(value)]="selectedCarAndLoader" 
              [dataSource]="carAndLoader" 
              displayExpr="carNumber" 
              valueExpr="id" 
              class="full-width-button" 
              (onValueChanged)="onSelectedVehicleChanged($event)"
              placeholder="{{ 'SelectVehicle' | translate }}">
            </dx-select-box>
          </dxi-item>
          <dxi-item>
            <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="success" (onClick)="saveClick()"></dx-button>
          </dxi-item>
          <dxi-item>
            <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="navigateToVoucher()"></dx-button>
          </dxi-item>
        </dx-form>
      </ng-template>
    </form>

    <div *ngIf="fuelResponse">
      <div class="container">
        <div *ngIf="fuelResponse">
          <label>{{ 'FuelPouredIn' | translate }}</label>
          <div *ngFor="let group of fuelResponse.fuelList">
            <div class="fuel-group">
              <label>{{ 'ReceiptNumber' | translate }}</label>
              <dx-text-box [(value)]="group.receiptNumber" class="full-width-button" [readOnly]="true" [inputAttr]="{ inputmode: 'numeric', pattern: '[0-9]*' }"></dx-text-box>
              <label>{{ 'FuelAmount' | translate }}</label>
              <dx-number-box [(value)]="group.fuelAmount" class="full-width-button" [readOnly]="true"></dx-number-box>
                <ng-container *ngIf="group.engineHours != null && group.engineHours !== 0">
                  <label>{{ 'EngineHours' | translate }}</label>
                  <dx-number-box [(value)]="group.engineHours" class="full-width-button" [readOnly]="true"></dx-number-box>
                </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <dx-popup [(visible)]="popupVisibleError" title="{{ 'Paziņojums' | translate }}" [width]="isMobile ? '100%' : '60%'"
    [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile" [hideOnOutsideClick]="false" [showCloseButton]="true">
      <div *dxTemplate="let data of 'content'">
        <p [innerHTML]="errorMessage"></p>
      </div>
    </dx-popup>
    <dx-popup
      [(visible)]="showPopup"
      [width]="isMobile ? '100%' : '60%'"
      [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile"
      [showTitle]="true"
      [hideOnOutsideClick]="false" [showCloseButton]="true"
      title="{{ 'Notification' | translate }}"
      (onHiding)="closePopup()">
      <div>{{ popupMessage }}</div>
    </dx-popup>
  </div>
</div>